export const cityOptions = [
  { label: "Abreu e Lima", value: "Abreu e Lima" },
  { label: "Afogados da Ingazeira", value: "Afogados da Ingazeira" },
  { label: "Afrânio", value: "Afrânio" },
  { label: "Agrestina", value: "Agrestina" },
  { label: "Água Preta", value: "Água Preta" },
  { label: "Águas Belas", value: "Águas Belas" },
  { label: "Alagoinha", value: "Alagoinha" },
  { label: "Aliança", value: "Aliança" },
  { label: "Altinho", value: "Altinho" },
  { label: "Amaraji", value: "Amaraji" },
  { label: "Angelim", value: "Angelim" },
  { label: "Araçoiaba", value: "Araçoiaba" },
  { label: "Araripina", value: "Araripina" },
  { label: "Arcoverde", value: "Arcoverde" },
  { label: "Barra de Guabiraba", value: "Barra de Guabiraba" },
  { label: "Barreiros", value: "Barreiros" },
  { label: "Belém de Maria", value: "Belém de Maria" },
  { label: "Belém do São Francisco", value: "Belém do São Francisco" },
  { label: "Belo Jardim", value: "Belo Jardim" },
  { label: "Betânia", value: "Betânia" },
  { label: "Bezerros", value: "Bezerros" },
  { label: "Bodocó", value: "Bodocó" },
  { label: "Bom Conselho", value: "Bom Conselho" },
  { label: "Bom Jardim", value: "Bom Jardim" },
  { label: "Bonito", value: "Bonito" },
  { label: "Brejão", value: "Brejão" },
  { label: "Brejinho", value: "Brejinho" },
  { label: "Brejo da Madre de Deus", value: "Brejo da Madre de Deus" },
  { label: "Buenos Aires", value: "Buenos Aires" },
  { label: "Buíque", value: "Buíque" },
  { label: "Cabo de Santo Agostinho", value: "Cabo de Santo Agostinho" },
  { label: "Cabrobó", value: "Cabrobó" },
  { label: "Cachoeirinha", value: "Cachoeirinha" },
  { label: "Caetés", value: "Caetés" },
  { label: "Calçado", value: "Calçado" },
  { label: "Calumbi", value: "Calumbi" },
  { label: "Camaragibe", value: "Camaragibe" },
  { label: "Camocim de São Félix", value: "Camocim de São Félix" },
  { label: "Camutanga", value: "Camutanga" },
  { label: "Canhotinho", value: "Canhotinho" },
  { label: "Capoeiras", value: "Capoeiras" },
  { label: "Carnaíba", value: "Carnaíba" },
  { label: "Carnaubeira da Penha", value: "Carnaubeira da Penha" },
  { label: "Carpina", value: "Carpina" },
  { label: "Caruaru", value: "Caruaru" },
  { label: "Casinhas", value: "Casinhas" },
  { label: "Catende", value: "Catende" },
  { label: "Cedro", value: "Cedro" },
  { label: "Chã de Alegria", value: "Chã de Alegria" },
  { label: "Chã Grande", value: "Chã Grande" },
  { label: "Condado", value: "Condado" },
  { label: "Correntes", value: "Correntes" },
  { label: "Cortês", value: "Cortês" },
  { label: "Cumaru", value: "Cumaru" },
  { label: "Cupira", value: "Cupira" },
  { label: "Custódia", value: "Custódia" },
  { label: "Dormentes", value: "Dormentes" },
  { label: "Escada", value: "Escada" },
  { label: "Exu", value: "Exu" },
  { label: "Feira Nova", value: "Feira Nova" },
  { label: "Fernando de Noronha", value: "Fernando de Noronha" },
  { label: "Ferreiros", value: "Ferreiros" },
  { label: "Flores", value: "Flores" },
  { label: "Floresta", value: "Floresta" },
  { label: "Frei Miguelinho", value: "Frei Miguelinho" },
  { label: "Gameleira", value: "Gameleira" },
  { label: "Garanhuns", value: "Garanhuns" },
  { label: "Glória do Goitá", value: "Glória do Goitá" },
  { label: "Goiana", value: "Goiana" },
  { label: "Granito", value: "Granito" },
  { label: "Gravatá", value: "Gravatá" },
  { label: "Iati", value: "Iati" },
  { label: "Ibimirim", value: "Ibimirim" },
  { label: "Ibirajuba", value: "Ibirajuba" },
  { label: "Igarassu", value: "Igarassu" },
  { label: "Iguaraci", value: "Iguaraci" },
  { label: "Ilha de Itamaracá", value: "Ilha de Itamaracá" },
  { label: "Inajá", value: "Inajá" },
  { label: "Ingazeira", value: "Ingazeira" },
  { label: "Ipojuca", value: "Ipojuca" },
  { label: "Ipubi", value: "Ipubi" },
  { label: "Itacuruba", value: "Itacuruba" },
  { label: "Itaíba", value: "Itaíba" },
  { label: "Itambé", value: "Itambé" },
  { label: "Itapetim", value: "Itapetim" },
  { label: "Itapissuma", value: "Itapissuma" },
  { label: "Itaquitinga", value: "Itaquitinga" },
  { label: "Jaboatão dos Guararapes", value: "Jaboatão dos Guararapes" },
  { label: "Jaqueira", value: "Jaqueira" },
  { label: "Jataúba", value: "Jataúba" },
  { label: "Jatobá", value: "Jatobá" },
  { label: "João Alfredo", value: "João Alfredo" },
  { label: "Joaquim Nabuco", value: "Joaquim Nabuco" },
  { label: "Jucati", value: "Jucati" },
  { label: "Jupi", value: "Jupi" },
  { label: "Jurema", value: "Jurema" },
  { label: "Lagoa de Itaenga", value: "Lagoa de Itaenga" },
  { label: "Lagoa do Carro", value: "Lagoa do Carro" },
  { label: "Lagoa do Ouro", value: "Lagoa do Ouro" },
  { label: "Lagoa dos Gatos", value: "Lagoa dos Gatos" },
  { label: "Lagoa Grande", value: "Lagoa Grande" },
  { label: "Lajedo", value: "Lajedo" },
  { label: "Limoeiro", value: "Limoeiro" },
  { label: "Macaparana", value: "Macaparana" },
  { label: "Machados", value: "Machados" },
  { label: "Manari", value: "Manari" },
  { label: "Maraial", value: "Maraial" },
  { label: "Mirandiba", value: "Mirandiba" },
  { label: "Moreilândia", value: "Moreilândia" },
  { label: "Moreno", value: "Moreno" },
  { label: "Nazaré da Mata", value: "Nazaré da Mata" },
  { label: "Olinda", value: "Olinda" },
  { label: "Orobó", value: "Orobó" },
  { label: "Orocó", value: "Orocó" },
  { label: "Ouricuri", value: "Ouricuri" },
  { label: "Palmares", value: "Palmares" },
  { label: "Palmeirina", value: "Palmeirina" },
  { label: "Panelas", value: "Panelas" },
  { label: "Paranatama", value: "Paranatama" },
  { label: "Parnamirim", value: "Parnamirim" },
  { label: "Passira", value: "Passira" },
  { label: "Paudalho", value: "Paudalho" },
  { label: "Paulista", value: "Paulista" },
  { label: "Pedra", value: "Pedra" },
  { label: "Pesqueira", value: "Pesqueira" },
  { label: "Petrolândia", value: "Petrolândia" },
  { label: "Petrolina", value: "Petrolina" },
  { label: "Poção", value: "Poção" },
  { label: "Pombos", value: "Pombos" },
  { label: "Primavera", value: "Primavera" },
  { label: "Quipapá", value: "Quipapá" },
  { label: "Quixaba", value: "Quixaba" },
  { label: "Recife", value: "Recife" },
  { label: "Riacho das Almas", value: "Riacho das Almas" },
  { label: "Ribeirão", value: "Ribeirão" },
  { label: "Rio Formoso", value: "Rio Formoso" },
  { label: "Sairé", value: "Sairé" },
  { label: "Salgadinho", value: "Salgadinho" },
  { label: "Salgueiro", value: "Salgueiro" },
  { label: "Saloá", value: "Saloá" },
  { label: "Sanharó", value: "Sanharó" },
  { label: "Santa Cruz", value: "Santa Cruz" },
  { label: "Santa Cruz da Baixa Verde", value: "Santa Cruz da Baixa Verde" },
  { label: "Santa Cruz do Capibaribe", value: "Santa Cruz do Capibaribe" },
  { label: "Santa Filomena", value: "Santa Filomena" },
  { label: "Santa Maria da Boa Vista", value: "Santa Maria da Boa Vista" },
  { label: "Santa Maria do Cambucá", value: "Santa Maria do Cambucá" },
  { label: "Santa Terezinha", value: "Santa Terezinha" },
  { label: "São Benedito do Sul", value: "São Benedito do Sul" },
  { label: "São Bento do Una", value: "São Bento do Una" },
  { label: "São Caetano", value: "São Caetano" },
  { label: "São João", value: "São João" },
  { label: "São Joaquim do Monte", value: "São Joaquim do Monte" },
  { label: "São José da Coroa Grande", value: "São José da Coroa Grande" },
  { label: "São José do Belmonte", value: "São José do Belmonte" },
  { label: "São José do Egito", value: "São José do Egito" },
  { label: "São Lourenço da Mata", value: "São Lourenço da Mata" },
  { label: "São Vicente Férrer", value: "São Vicente Férrer" },
  { label: "Serra Talhada", value: "Serra Talhada" },
  { label: "Serrita", value: "Serrita" },
  { label: "Sertânia", value: "Sertânia" },
  { label: "Sirinhaém", value: "Sirinhaém" },
  { label: "Solidão", value: "Solidão" },
  { label: "Surubim", value: "Surubim" },
  { label: "Tabira", value: "Tabira" },
  { label: "Tacaimbó", value: "Tacaimbó" },
  { label: "Tacaratu", value: "Tacaratu" },
  { label: "Tamandaré", value: "Tamandaré" },
  { label: "Taquaritinga do Norte", value: "Taquaritinga do Norte" },
  { label: "Terezinha", value: "Terezinha" },
  { label: "Terra Nova", value: "Terra Nova" },
  { label: "Timbaúba", value: "Timbaúba" },
  { label: "Toritama", value: "Toritama" },
  { label: "Tracunhaém", value: "Tracunhaém" },
  { label: "Trindade", value: "Trindade" },
  { label: "Triunfo", value: "Triunfo" },
  { label: "Tupanatinga", value: "Tupanatinga" },
  { label: "Tuparetama", value: "Tuparetama" },
  { label: "Venturosa", value: "Venturosa" },
  { label: "Verdejante", value: "Verdejante" },
  { label: "Vertente do Lério", value: "Vertente do Lério" },
  { label: "Vertentes", value: "Vertentes" },
  { label: "Vicência", value: "Vicência" },
  { label: "Vitória de Santo Antão", value: "Vitória de Santo Antão" },
  { label: "Xexéu", value: "Xexéu" },
];